import React from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import Container from 'ls-common-client/dist/components/Container';
import Text from 'ls-common-client/dist/components/Text';
import BluePin from '../../assets/mapPinRed.png';
import MapPlaceholderImage from '../../assets/mapPlaceholder.png';
import config from '../../../src/client/config';

const StyledRoot = styled(Container)`
  position: relative;
  width: 100%;
  height: auto;
`;

const StyledMarker = styled(Text)`
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 16px;
  }
`;

const StyledMap = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
`;

const StyledPlaceholder = styled(Container)`
  width: 100%;
  height: 100px;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;

  a {
    color: #555555;
    width: 83px;
    border: solid 1px #d2d2d2;
    cursor: pointer;
    height: 36px;
    display: flex;
    z-index: 1;
    position: relative;
    font-size: 10px;
    background: #fbfcff;
    align-items: center;
    font-weight: 600;
    border-radius: 2px;
    justify-content: center;
  }
  div {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    background-size: cover;
    background-position: center;
  }
`;

const { googleMapKey } = config;

function Static({
  center,
  width = 900,
  height = 900,
  zoom = '11',
  mapPin = true,
  pin = BluePin,
  link = undefined,
  placeHolder = false,
  className,
}) {
  return (
    <StyledRoot
      className={classNames('Maps__Static__root', {
        [className]: className,
      })}
    >
      {mapPin && !placeHolder && (
        <StyledMarker className="Maps__Static__marker">
          <img src={pin} alt="" />
        </StyledMarker>
      )}
      {placeHolder ? (
        <StyledPlaceholder className="Maps__Static__placeholder">
          <div
            style={{
              backgroundImage: `url(${MapPlaceholderImage})`,
            }}
          />
          {link && (
            <a rel="nofollow" href={link} target="_blank">
              View Map
            </a>
          )}
        </StyledPlaceholder>
      ) : (
        <StyledMap
          className="Maps__Static__map"
          src={
            `https://maps.googleapis.com/maps/api/staticmap?size=${width}x${height}` +
            `&center=${center}` +
            `&zoom=${zoom}` +
            '&sensor=false' +
            `&key=${googleMapKey}`
          }
          alt=""
        />
      )}
    </StyledRoot>
  );
}

export default Static;
